import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

/**
 * Enables keyboard-only users to quickly set focus to the main content.
 * Is hidden for mouse users.
 */
const SkipNavigation = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 1500,
      }}
    >
      <Box
        component="a"
        href="#start-of-content"
        sx={{
          '&:focus': {
            clip: 'auto',
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
            height: 'auto',
            lineHeight: theme.appBar.height,
            padding: '0 10px',
            textAlign: 'center',
            textDecoration: 'none',
            top: 0,
            width: '100%',
          },
          backgroundColor: theme.palette.primary.main,
          // Most of the next styles are used to make the element
          // both hidden, yet selectable across a large set of browsers
          clip: 'rect(1px, 1px, 1px, 1px)',
          height: '1px',
          margin: '0',
          overflow: 'hidden',
          position: 'fixed',
          top: '-100px',
          width: '1px',
          willChange: 'transform',
        }}
      >
        {t('navbar.skipNavigation')}
      </Box>
    </Box>
  );
};

export default SkipNavigation;
